const SERVICE_DEPENDENCIES = {
  whitening: { requires: ['cleaning'], within: '6 months', question: 'lastCleaningDate' },
  implant: { requires: ['ctScan', 'consultation'], question: 'hasCtScan' },
  orthodonticAdjustment: { requires: ['bracesPlacement'], question: 'hasBraces' },
  rootCanal: { requires: ['xray'], question: 'hasRecentXray' }
}

export const checkPrerequisites = (serviceId, answers) => {
  const dep = SERVICE_DEPENDENCIES[serviceId]
  if (!dep) return { passed: true, missing: [], dependency: null }

  const missing = []

  if (dep.question === 'lastCleaningDate') {
    const dateVal = answers.lastCleaningDate
    if (!dateVal) {
      missing.push('cleaning')
    } else {
      const cleaningDate = new Date(dateVal)
      const sixMonthsAgo = new Date()
      sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6)
      if (cleaningDate < sixMonthsAgo) missing.push('cleaning')
    }
  }

  if (dep.question === 'hasCtScan') {
    if (!answers.hasCtScan) missing.push('ctScan')
    if (!answers.hasConsultation) missing.push('consultation')
  }

  if (dep.question === 'hasBraces') {
    if (!answers.hasBraces) missing.push('bracesPlacement')
  }

  if (dep.question === 'hasRecentXray') {
    if (!answers.hasRecentXray) missing.push('xray')
  }

  return { passed: missing.length === 0, missing, dependency: dep }
}
